var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-checkbox-group',_vm._g(_vm._b({attrs:{"value":_vm.value}},'el-checkbox-group',_vm.$attrs,false),_vm.$listeners),_vm._l((_vm.options),function(item,index){return _c('el-checkbox',{key:index,attrs:{"label":item.id}},[_vm._v(_vm._s(item.classname))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }